import { ShieldCheck, Zap, MapPin, Target, Heart } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import Seo from "@/components/Seo";
import { STORE, waLink } from "@/lib/constants";

const VALUES = [
  { icon: ShieldCheck, title: "Original & Resmi", desc: "Kami hanya menjual produk asli bergaransi resmi Indonesia." },
  { icon: Zap, title: "Selalu Brand New", desc: "Setiap unit dalam kondisi baru & tersegel dari distributor." },
  { icon: Heart, title: "Pelayanan Personal", desc: "Konsultasi ramah & jujur agar Anda dapat produk paling tepat." },
];

export default function TentangKami() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-14 sm:px-6">
      <Seo title="Tentang Kami" path="/tentang-kami" description="Kenali BigBerry Store — reseller gadget premium bergaransi resmi di Jakarta." />

      <p className="text-sm font-medium uppercase tracking-widest text-berry">Tentang Kami</p>
      <h1 className="mt-1 font-heading text-4xl font-800 tracking-tight text-white">Kenalan dengan BigBerry Store</h1>

      <div className="mt-6 space-y-4 text-gray-300">
        <p>
          <strong className="text-white">BigBerry Store</strong> adalah reseller gadget premium yang
          berfokus pada produk <strong className="text-white">brand new bergaransi resmi</strong> dari
          brand ternama dunia — Apple, Samsung, Google, GoPro, JBL, Bose, Harman Kardon, Meta,
          Microsoft, dan Beats.
        </p>
        <p>
          Kami hadir untuk memudahkan konsumen Indonesia memiliki gadget original dengan proses yang
          simpel dan transparan. Dengan dukungan berbagai opsi cicilan/BNPL, gadget impian jadi lebih
          terjangkau. Semua transaksi kami tangani secara personal via WhatsApp agar Anda mendapat
          harga terkini serta pendampingan penuh.
        </p>
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-3">
        {VALUES.map((v) => (
          <div key={v.title} className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
            <div className="mb-4 inline-flex rounded-xl bg-berry/10 p-3 text-berry">
              <v.icon className="h-6 w-6" />
            </div>
            <h3 className="font-heading text-lg font-600 text-white">{v.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">{v.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
          <div className="mb-3 inline-flex rounded-xl bg-electric/10 p-3 text-electric"><Target className="h-6 w-6" /></div>
          <h3 className="font-heading text-lg font-600 text-white">Misi Kami</h3>
          <p className="mt-2 text-sm leading-relaxed text-gray-400">
            Menjadi tempat terpercaya untuk membeli gadget original bergaransi resmi dengan pengalaman
            belanja yang cepat, jujur, dan fleksibel.
          </p>
        </div>
        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
          <div className="mb-3 inline-flex rounded-xl bg-electric/10 p-3 text-electric"><MapPin className="h-6 w-6" /></div>
          <h3 className="font-heading text-lg font-600 text-white">Lokasi Operasional</h3>
          <p className="mt-2 text-sm leading-relaxed text-gray-400">{STORE.address}</p>
        </div>
      </div>

      <div className="mt-10 rounded-3xl border border-white/10 bg-gradient-to-br from-berry/20 to-[#12141C] p-8 text-center md:p-12">
        <h2 className="font-heading text-2xl font-700 tracking-tight text-white md:text-3xl">Mari terhubung dengan kami</h2>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 rounded-full bg-whatsapp px-7 py-3.5 font-semibold text-white transition-all duration-300 hover:scale-105 hover:bg-whatsapp-dark">
          <FaWhatsapp className="h-5 w-5" /> Chat via WhatsApp
        </a>
      </div>
    </div>
  );
}
